module.exports = __webpack_public_path__ + "img/goblin.91b9706f.webp";